interface StatCardProps {
  title: string;
  value: string;
  change: string;
  changeType: 'up' | 'down' | 'neutral';
  icon: string;
  bgColor: string;
  iconColor: string;
}

export default function StatCard({ title, value, change, changeType, icon, bgColor, iconColor }: StatCardProps) {
  return (
    <div className={`${bgColor} rounded-2xl p-5 relative overflow-hidden`}>
      <div className={`absolute right-4 top-4 w-14 h-14 flex items-center justify-center ${iconColor} opacity-15`}>
        <i className={`${icon} text-5xl`}></i>
      </div>
      <p className="text-gray-500 text-xs font-medium mb-2">{title}</p>
      <p className="text-gray-800 font-bold text-2xl mb-2">{value}</p>
      {changeType !== 'neutral' ? (
        <div className={`flex items-center gap-1 text-xs font-medium ${changeType === 'up' ? 'text-emerald-600' : 'text-red-500'}`}>
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={changeType === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}></i>
          </span>
          {change} so với tháng trước
        </div>
      ) : (
        <div className="flex items-center gap-1 text-xs font-medium text-gray-400">
          {change}
        </div>
      )}
    </div>
  );
}